import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, formatListData, AppContext, EMPTY_OBJECT, UserContext } from 'commons-ui';

import { PAGE_NAMES, ACTION, USER_PROFILE_RESOURCES } from 'constant';
import { PayInFilter } from './constants';

const useService = () => {
	const { app } = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const { permissionsConfig } = useContext(UserContext);
	const getPaymentStatus = useCallback(async (filtersData: PayInFilter) => {
		const { appName } = app;
		const { merchantName, orderId } = filtersData;
		const permission = _find(permissionsConfig, { actionName: ACTION.getPaymentStatus });

		const result = await postData({
			endpoint: `/dashboard/getPaymentStatus/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.transactionHistory}-getPaymentStatus`,
			queryParams: {
				appName
			},
			body: { merchant: merchantName, orderId },
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
		const data = _get(result, ['data', 'data'], EMPTY_OBJECT);

		return { rowCount: data.length, data: formatListData([data]) };
	}, []);

	return { getPaymentStatus };
};

export default useService;
